import { get, post, put, destroy } from 'utils/fetchRequest';

export const getActivitySummaries = async (search) => {
    try {
        return await get(
            `activity-summary${search ? `?search=${search}` : ''}`
        );
    } catch (err) {
        return { error: err };
    }
};

export const getActivitySummary = async (id) => {
    try {
        return await get(`activity-summary/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const createActivitySummary = async (data) => {
    try {
        return await post('activity-summary', data);
    } catch (err) {
        return { error: err };
    }
};

export const updateActivitySummary = async (id, data) => {
    try {
        return await put(`activity-summary/${id}`, data);
    } catch (err) {
        return { error: err };
    }
};

export const deleteActivitySummary = async (id) => {
    try {
        return await destroy(`activity-summary/${id}`);
    } catch (err) {
        return { error: err };
    }
};